// import { useEffect, useState } from "react";
// import categories from "../data/categories"; 
// import { getProducts } from "../data/products"; 
// import FeaturedCategories from "../components/FeaturedCategories";
// import HeroCarousel from "../components/HeroCarousel";
// import ContactCTA from "../components/ContactCTA";
// import NewArrivalsSwiper from "../components/NewArrivalsSwiper";
// import { Link } from "react-router-dom";
// import AboutProduct from "../components/AboutProduct";
// import { WhyChoose } from "../components/WhyChoose";
// import Expert from "../components/Expert";
// import Status from "../components/Status";
// import Testimonials from "../components/Testimonials";
// import SEO from "../components/SEO";

// export default function Home() {
//   const [products, setProducts] = useState([]);

//   // ✅ Fetch products from Backend (MongoDB) 
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const data = await getProducts(); 
//         setProducts(data);
//       } catch (error) {
//         console.error("Error fetching products:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   const popularProducts = products.slice(0, 4);

//   const homeFaqs = [
//     {
//       question: "How does Holly Zolly support Vastu-friendly living?",
//       answer:
//         "We provide authentic Vastu products, yantras, and expert consultation to help you create a balanced, prosperous, and peaceful home environment.",
//     },
//     {
//       question: "Can I order ancient yantras and Vastu items online?",
//       answer:
//         "Yes, our curated collection of sacred products is available for online purchase with secure delivery across India.",
//     },
//     {
//       question: "Do you offer Vastu guidance for homes and offices?",
//       answer:
//         "Yes, Holly Zolly offers tailored Vastu advice for residential and commercial spaces to improve harmony and wellbeing.",
//     },
//     {
//       question: "Is product authenticity guaranteed?",
//       answer:
//         "Every item is selected for Vastu alignment and crafted to support positive energy, clarity, and prosperity in your space.",
//     },
//   ];

//   const faqSchema = {
//     "@context": "https://schema.org",
//     "@type": "FAQPage",
//     mainEntity: homeFaqs.map((faq) => ({
//       "@type": "Question",
//       name: faq.question,
//       acceptedAnswer: {
//         "@type": "Answer",
//         text: faq.answer,
//       },
//     })),
//   };

//   return (
//     <div className="bg-white">
//       <SEO
//         title="Holly Zolly | Vastu Products, Yantras & Expert Vastu Consultation"
//         description="Discover authentic Vastu products, sacred yantras, and harmonious home solutions at Holly Zolly. Shop our top collections for energy balance, prosperity, and peace."
//         schema={faqSchema}
//       />
//       {/* HERO */}
//       <HeroCarousel />

//       {/* FEATURED CATEGORIES */}
//       <FeaturedCategories />

//       {/* POPULAR COLLECTION */}
//       <section className="py-24 bg-[#fcfaf8] relative overflow-hidden">
//         <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-96 h-96 bg-orange-100/50 rounded-full blur-3xl"></div>

//         <div className="max-w-7xl mx-auto px-6 relative z-10">
//           {/* Header */}
//           <div className="flex flex-col items-center text-center mb-16">
//             <span className="bg-orange-100 text-orange-700 px-4 py-1 rounded-full text-xs font-bold uppercase tracking-widest">
//               Top Rated
//             </span>
//             <h2 className="text-4xl md:text-5xl font-heading font-bold text-slate-900 mt-4">
//               Our Popular <span className="text-orange-600">Vastu Collection</span>
//             </h2>
//             <p className="text-gray-600 mt-4 max-w-2xl text-lg">
//               Explore our most loved categories designed to bring harmony,
//               prosperity, and positivity to your sacred space.
//             </p>
//           </div>

//           {/* GRID */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
//             {popularProducts.map((item, index) => (
//               <Link
//                 key={item._id} // MongoDB ID
//                 to={`/product/${item._id}`} // Slug વગર સીધી ID
//                 className="group relative"
//                 data-aos="fade-up"
//                 data-aos-delay={index * 150}
//               >
//                 <div className="relative overflow-hidden rounded-[2rem] bg-white p-3 shadow-lg transition-all duration-500 group-hover:shadow-2xl group-hover:-translate-y-2">
//                   <div className="overflow-hidden rounded-[1.5rem] h-80">
//                     <img
//                       src={item.images?.[0] || item.image || "/placeholder.png"}
//                       alt={item.name}
//                       loading="lazy"
//                       decoding="async"
//                       className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
//                     />
//                   </div>

//                   {/* Hover Overlay */}
//                   <div className="absolute inset-0 bg-gradient-to-t from-orange-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition duration-500 flex flex-col justify-end p-8">
//                     <p className="text-white/80 text-sm mb-1 uppercase tracking-widest">
//                       View Product
//                     </p>
//                     <h3 className="text-white text-2xl font-bold">
//                       {item.name}
//                     </h3>
//                   </div>
//                 </div>

//                 {/* Default Bottom Name (Hidden on Hover) */}
//                 <div className="mt-6 text-center transition-all duration-300 group-hover:opacity-0">
//                   <h3 className="text-xl font-heading font-bold text-slate-800">
//                     {item.name}
//                   </h3>
//                   <div className="w-10 h-0.5 bg-orange-400 mx-auto mt-2 transition-all group-hover:w-20"></div>
//                 </div>
//               </Link>
//             ))}
//           </div>

//           {/* Button */}
//           <div className="mt-16 text-center">
//             <Link
//               to="/shop"
//               className="inline-block border-2 border-orange-600 text-orange-600 px-8 py-3 rounded-full font-bold hover:bg-orange-600 hover:text-white transition-all duration-300 shadow-md"
//             >
//               View Full Collection
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* NEW ARRIVALS */}
//       <div className="bg-white">
//         <NewArrivalsSwiper />
//       </div>

//       <div className="bg-white">
//         <AboutProduct/>
//       </div>

//       <div className="bg-white">
//         <WhyChoose/>
//       </div>

//       <div className="bg-gray">  
//         <Expert/>
//       </div>

//       <div className="bg-white">
//         <Status/>
//       </div>

//       <div className="bg-white">
//         <Testimonials/>
//       </div>

//       {/* FAQ SCHEMA SECTION */}
//       <section className="py-20 bg-[#f9f6f0]">
//         <div className="max-w-6xl mx-auto px-6">
//           <div className="text-center mb-12">
//             <span className="text-sm uppercase tracking-[0.35em] text-orange-600 font-bold">
//               FAQ
//             </span>
//             <h2 className="mt-4 text-4xl font-heading font-bold text-slate-900">
//               Common Questions About Our Vastu Products
//             </h2>
//             <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
//               Learn how Holly Zolly helps you choose the best Vastu items, yantras, and consultation services for your home or workspace.
//             </p>
//           </div>

//           <div className="grid gap-6 md:grid-cols-2">
//             {homeFaqs.map((faq, index) => (
//               <div
//                 key={index}
//                 className="bg-white p-6 rounded-3xl border border-stone-200 shadow-sm"
//               >
//                 <h3 className="text-xl font-semibold text-stone-900 mb-3">
//                   {faq.question}
//                 </h3>
//                 <p className="text-gray-600 leading-7">{faq.answer}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CONTACT */}
//       <ContactCTA />
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import categories from "../data/categories"; 
import { getProducts } from "../data/products"; 
import FeaturedCategories from "../components/FeaturedCategories";
import HeroCarousel from "../components/HeroCarousel";
import ContactCTA from "../components/ContactCTA";
import NewArrivalsSwiper from "../components/NewArrivalsSwiper";
import { Link } from "react-router-dom";
import AboutProduct from "../components/AboutProduct";
import { WhyChoose } from "../components/WhyChoose";
import Expert from "../components/Expert";
import Status from "../components/Status";
import Testimonials from "../components/Testimonials";
import SEO from "../components/SEO";

// ✅ Loader Component
const ProductLoader = () => (
  <div className="flex flex-col items-center justify-center py-12">
    <div className="flex items-center justify-center mb-5">
      <div className="h-16 w-16 rounded-full border-4 border-orange-200 border-t-orange-600 animate-spin"></div>
    </div>

    <p className="text-lg font-semibold text-slate-800 tracking-wide">
      Loading Vastu Collection...
    </p>
    <p className="text-sm text-slate-500 mt-2">
      Preparing your sacred products for you
    </p>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mt-10 w-full">
      {[...Array(4)].map((_, index) => (
        <div key={index} className="group relative">
          <div className="relative overflow-hidden rounded-[2rem] bg-white p-3 shadow-lg">
            <div className="overflow-hidden rounded-[1.5rem] h-80 bg-gray-200 animate-pulse">
              <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer"></div>
            </div>
            <div className="mt-6 text-center">
              <div className="h-6 bg-gray-200 rounded w-3/4 mx-auto animate-pulse"></div>
              <div className="w-10 h-0.5 bg-gray-200 mx-auto mt-2"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default function Home() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  // ✅ Fetch products from Backend (MongoDB)
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setImagesLoaded(false);

        const data = await getProducts();
        setProducts(data);

        // ✅ Preload only the first visible product images for smoother experience
        const visibleProducts = data.slice(0, 4);

        if (visibleProducts.length > 0) {
          await Promise.all(
            visibleProducts.map(
              (item) =>
                new Promise((resolve) => {
                  const img = new Image();
                  img.src = item.images?.[0] || item.image || "/placeholder.png";
                  img.onload = () => resolve(true);
                  img.onerror = () => resolve(false);
                })
            )
          );
        }

        setImagesLoaded(true);
      } catch (error) {
        console.error("Error fetching products:", error);
        setProducts([]);
      } finally {
        setLoading(false);
        setImagesLoaded(true);
      }
    };

    fetchData();
  }, []);

  const popularProducts = products.slice(0, 4);

  const homeFaqs = [
    {
      question: "How does Holly Zolly support Vastu-friendly living?",
      answer:
        "We provide authentic Vastu products, yantras, and expert consultation to help you create a balanced, prosperous, and peaceful home environment.",
    },
    {
      question: "Can I order ancient yantras and Vastu items online?",
      answer:
        "Yes, our curated collection of sacred products is available for online purchase with secure delivery across India.",
    },
    {
      question: "Do you offer Vastu guidance for homes and offices?",
      answer:
        "Yes, Holly Zolly offers tailored Vastu advice for residential and commercial spaces to improve harmony and wellbeing.",
    },
    {
      question: "Is product authenticity guaranteed?",
      answer:
        "Every item is selected for Vastu alignment and crafted to support positive energy, clarity, and prosperity in your space.",
    },
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: homeFaqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <div className="bg-white">
      <SEO
        title="Holly Zolly | Vastu Products, Yantras & Expert Vastu Consultation"
        description="Discover authentic Vastu products, sacred yantras, and harmonious home solutions at Holly Zolly. Shop our top collections for energy balance, prosperity, and peace."
        schema={faqSchema}
      />
      {/* HERO */}
      <HeroCarousel />

      {/* FEATURED CATEGORIES */}
      <FeaturedCategories />

      {/* POPULAR COLLECTION */}
      <section className="py-24 bg-[#fcfaf8] relative overflow-hidden">
        <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-96 h-96 bg-orange-100/50 rounded-full blur-3xl"></div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* Header */}
          <div className="flex flex-col items-center text-center mb-16">
            <span className="bg-orange-100 text-orange-700 px-4 py-1 rounded-full text-xs font-bold uppercase tracking-widest">
              Top Rated
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-slate-900 mt-4">
              Our Popular <span className="text-orange-600">Vastu Collection</span>
            </h2>
            <p className="text-gray-600 mt-4 max-w-2xl text-lg">
              Explore our most loved categories designed to bring harmony,
              prosperity, and positivity to your sacred space.
            </p>
          </div>

          {/* ✅ Show Loader or Products */}
          {loading || !imagesLoaded ? (
            <ProductLoader />
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
              {popularProducts.map((item, index) => (
                <Link
                  key={item._id}
                  to={`/product/${item._id}`}
                  className="group relative"
                  data-aos="fade-up"
                  data-aos-delay={index * 150}
                >
                  <div className="relative overflow-hidden rounded-[2rem] bg-white p-3 shadow-lg transition-all duration-500 group-hover:shadow-2xl group-hover:-translate-y-2">
                    <div className="overflow-hidden rounded-[1.5rem] h-80">
                      <img
                        src={item.images?.[0] || item.image || "/placeholder.png"}
                        alt={item.name}
                        loading="lazy"
                        decoding="async"
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        onLoad={() => {
                          // Individual image loaded
                        }}
                      />
                    </div>

                    {/* Hover Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-orange-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition duration-500 flex flex-col justify-end p-8">
                      <p className="text-white/80 text-sm mb-1 uppercase tracking-widest">
                        View Product
                      </p>
                      <h3 className="text-white text-2xl font-bold">
                        {item.name}
                      </h3>
                    </div>
                  </div>

                  {/* Default Bottom Name */}
                  <div className="mt-6 text-center transition-all duration-300 group-hover:opacity-0">
                    <h3 className="text-xl font-heading font-bold text-slate-800">
                      {item.name}
                    </h3>
                    <div className="w-10 h-0.5 bg-orange-400 mx-auto mt-2 transition-all group-hover:w-20"></div>
                  </div>
                </Link>
              ))}
            </div>
          )}

          {/* Button */}
          <div className="mt-16 text-center">
            <Link
              to="/shop"
              className="inline-block border-2 border-orange-600 text-orange-600 px-8 py-3 rounded-full font-bold hover:bg-orange-600 hover:text-white transition-all duration-300 shadow-md"
            >
              View Full Collection
            </Link>
          </div>
        </div>
      </section>

      {/* NEW ARRIVALS */}
      <div className="bg-white">
        <NewArrivalsSwiper />
      </div>

      <div className="bg-white">
        <AboutProduct/>
      </div>

      <div className="bg-white">
        <WhyChoose/>
      </div>

      <div className="bg-gray">  
        <Expert/>
      </div>

      <div className="bg-white">
        <Status/>
      </div>

      <div className="bg-white">
        <Testimonials/>
      </div>

      {/* FAQ SCHEMA SECTION */}
      <section className="py-20 bg-[#f9f6f0]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-sm uppercase tracking-[0.35em] text-orange-600 font-bold">
              FAQ
            </span>
            <h2 className="mt-4 text-4xl font-heading font-bold text-slate-900">
              Common Questions About Our Vastu Products
            </h2>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
              Learn how Holly Zolly helps you choose the best Vastu items, yantras, and consultation services for your home or workspace.
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-2">
            {homeFaqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-3xl border border-stone-200 shadow-sm"
              >
                <h3 className="text-xl font-semibold text-stone-900 mb-3">
                  {faq.question}
                </h3>
                <p className="text-gray-600 leading-7">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <ContactCTA />
    </div>
  );
}